import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const sideLoadedDataSetSerializeMap: SerializeMap<SideLoadedDataSet> = {
  id: "id",
  name: "name",
  recordCount: "record_count",
  created: "created",
};

export const serializeSideLoadedDataSet = buildSerializer(
  sideLoadedDataSetSerializeMap,
  "sideLoadedDataSet",
);

export const deserializeSideLoadedDataSet = buildDeserializer(
  sideLoadedDataSetSerializeMap,
  "sideLoadedDataSet",
);
